<template>
  <div>
    <button @click="initiateAddContact()" class="btn mb-3 btn-primary btn-md" :hidden="cantEditFicheDC(dossier)">Créer une fiche contact</button>
    <v-client-table id="table-communication" ref="table-cmmunication" :columns="columns" :data="items" :options="options">
      <div slot="action" slot-scope="props">
        <i class="fa fa-search mr-2 text-primary fa-1_5x align-middle clickable" @click="showCommunication(props.row)"></i>
        <i v-if="can('editContact',props.row)" class="fa fa-edit mr-2 text-primary fa-1_5x align-middle clickable" @click="editContact(props.row)" :hidden="cantEditFicheDC(dossier)"></i>
        <i v-if="can('deleteContact',props.row)" class="fa fa-trash text-danger clickable" @click="deleteContact(props.row.id)" :hidden="cantEditFicheDC(dossier)"></i>
      </div>
    </v-client-table>
    <b-card no-body v-if="showCardInfosCommunication">
      <div class="card-smallHeader" v-b-toggle.collapse-infos-communication>
        <span style="color:#73818f"><b>{{ titleCommunicationContact }}</b></span>
        <div class="card-header-actions">
          <span class="when-opened">
            <i class="icon-arrow-down"></i>
          </span>
          <span class="when-closed">
            <i class="icon-arrow-up"></i>
          </span>
        </div>
      </div>
      <b-collapse id="collapse-infos-communication" class="m-3 pl-1 pr-1" v-model="collapseInfosCommunication" :class="collapseInfosCommunication ? null : 'collapsed'">
        <button @click="initiateAddCommunication()" size="sm" class="btn mb-3 btn-primary btn-md" :hidden="cantEditFicheDC(dossier)">Créer un entretien</button>
        <b-card no-body class="overflow-hidden" v-for="communication in contactCommunications" :key="communication.id">
          <b-row no-gutters>
            <b-col sm="2" class="border-right" style="background-color: #F9FDFF;">
              <b-card-body class="pt-1 pb-1">
                <span class="d-inline-block font-weight-bold" style="width: 40px">Type </span>: {{ communication.type ? capitalizeFirstLetter(communication.type) : communication.type }}<br>
                <span class="d-inline-block font-weight-bold" style="width: 40px">Le </span>: {{ formatDate(communication.date_communication) }} à {{ communication.heure_communication }}<br>

                <span class="d-inline-block font-weight-bold" style="width: 40px">Par </span>: {{ communication.gestionnaire ? communication.gestionnaire.prenom + ' ' + communication.gestionnaire.nom : '' }}

              </b-card-body>
            </b-col>
            <b-col sm="10">
              <b-card-body class="pt-1 pb-1" style="background-color: #F9FDFF;">
                <b-card-text>
                  <div class="d-inline-block w-100" style="background-color: #EAF8FF;">
                  <span class="d-inline-block font-weight-bold" style="width: 60px;">Sujet </span>: {{ communication.sujet }}
                  <i v-if="can('deleteCommunication',communication)" class="fa fa-trash text-danger fa-1_5x align-middle clickable float-right" @click="deleteCommunication(communication.id)" :hidden="cantEditFicheDC(dossier)"></i>
                  <i v-if="can('editCommunication',communication)" class="fa fa-edit mr-2 text-primary fa-1_5x align-middle clickable float-right" @click="editCommunication(communication)" :hidden="cantEditFicheDC(dossier)"></i>
                  </div>
                  <hr class="mb-1 mt-1">
                  <span class="d-inline-block align-top font-weight-bold" style="width: 60px">Contenu </span><span class="d-inline-block align-top">:&nbsp;</span> <div class="pre-formatted d-inline-block">{{ communication.contenu }}</div>
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
        <b-row>
          <b-col sm="12">
            <button type="button" class="btn btn-secondary mr-2 float-right" @click="closeInfoCommunication()">Fermer</button>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>

    <b-modal size="xl" no-close-on-esc no-close-on-backdrop hide-header-close centered id="modal-contact" ref="modal-contact" :title="titleModalContact">
      <b-row>
        <b-col sm="6">
          <b-form-group
            label-for="nomInterlocuteur"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Nom interlocuteur</b></template>
            <b-form-input id="nomInterlocuteur" type="text" v-model="nomInterlocuteur" :disabled="isDisabled()" :class="{hasError: errors.nomInterlocuteur !== ''}">
            </b-form-input>
            <span class="field-error inline mr-1 float-right">{{ errors.nomInterlocuteur }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label-for="prenomInterlocuteur"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Prénom interlocuteur</b></template>
            <b-form-input id="prenomInterlocuteur" type="text" v-model="prenomInterlocuteur" :disabled="isDisabled()" :class="{hasError: errors.prenomInterlocuteur !== ''}">
            </b-form-input>
            <span class="field-error inline mr-1 float-right">{{ errors.prenomInterlocuteur }}</span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group
            label-for="emailInterlocuteur"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Mail interlocuteur</b></template>
            <b-form-input id="emailInterlocuteur" type="text" v-model="emailInterlocuteur" :disabled="isDisabled()">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label-for="telephoneInterlocuteur"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Téléphone interlocuteur</b></template>
            <b-form-input id="telephoneInterlocuteur" type="text" v-model="telephoneInterlocuteur" :disabled="isDisabled()">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group
            label-for="fonction"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Fonction / lien</b></template>
            <b-form-input id="fonction" type="text" v-model="fonction" :disabled="isDisabled()">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModalContact()">Annuler</button>
          <button type="button" @click="saveContact()" class="btn btn-warning"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" no-close-on-esc no-close-on-backdrop hide-header-close centered id="modal-communication" ref="modal-communication" :title="titleModalCommunication">
      <b-row>
        <b-col sm="6">
          <b-form-group
            label-for="dateCommunication"
            :label-cols="6"
            :horizontal="true">
            <template slot="label"><b>Date appel</b></template>
            <b-form-input id="dateCommunication" type="date" v-model="dateCommunication" :disabled="isDisabled()" :class="{hasError: errors.dateCommunication !== ''}">
            </b-form-input>
            <span class="field-error inline mr-1 float-right">{{ errors.dateCommunication }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label-for="heureCommunication"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Heure appel</b></template>
            <b-form-input id="heureCommunication" type="time" v-model="heureCommunication" :disabled="isDisabled()">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group
            label-for="type"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Type de la communication</b></template>
            <b-form-select v-model="selectedType" :options="typeOptions" :class="{hasError: errors.selectedType !== ''}">
              <template v-slot:first>
                <b-form-select-option :value="''" disabled>-- Choisir le type --</b-form-select-option>
              </template>
            </b-form-select>
            <span class="field-error inline mr-1 float-right">{{ errors.selectedType }}</span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group
            label-for="sujet"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Sujet de l'entretien</b></template>
            <b-form-input id="sujet" type="text" v-model="sujet" :disabled="isDisabled()" :class="{hasError: errors.sujet !== ''}">
            </b-form-input>
            <span class="field-error inline mr-1 float-right">{{ errors.sujet }}</span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group
            label-for="contenu"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Contenu de l'entretien</b></template>
            <b-form-textarea
              id="contenu"
              type="text"
              rows="3"
              max-rows="6"
              :disabled="isDisabled()"
              v-model="contenu"
              :class="{hasError: errors.contenu !== ''}">
            </b-form-textarea>
            <span class="field-error inline mr-1 float-right">{{ errors.contenu }}</span>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModalCommunication()">Annuler</button>
          <button type="button" @click="saveCommunication()" class="btn btn-warning"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { isEmpty } from '@/utils/fileHelper';
  import { getUser } from '@/utils/auth';
  import { cantEditFicheDC } from "@/utils/communHelper";

  export default {
    name: "Communications",
    data() {
      return {
        contactId: null,
        communicationId: null,
        dateCommunication: '',
        heureCommunication: '',
        nomInterlocuteur: '',
        prenomInterlocuteur: '',
        telephoneInterlocuteur: '',
        emailInterlocuteur: '',
        fonction: '',
        sujet: '',
        contenu: '',
        contactCommunications: [],
        titleModalContact: '',
        titleModalCommunication: '',
        titleCommunicationContact: '',
        showCardInfosCommunication: false,
        collapseInfosCommunication: true,
        selectedType: '',
        typeOptions: [
          {text: 'Entrant', value: 'entrant'},
          {text: 'Sortant', value: 'sortant'},
        ],
        columns: [
          // 'date_communication',
          // 'type',
          'nom_interlocuteur',
          'prenom_interlocuteur',
          'telephone_interlocuteur',
          'email_interlocuteur',
          'fonction',
          // 'sujet',
          // 'contenu',
          'action'
        ],
        items: [],
        options: {
          headings: {
            // date_communication: 'Date appel',
            // type: 'Type',
            nom_interlocuteur: 'Nom interlocuteur',
            prenom_interlocuteur: 'Prénom interlocuteur',
            telephone_interlocuteur: 'Tél interlocuteur',
            email_interlocuteur: 'Email interlocuteur',
            fonction: 'Fonction / Lien',
            // sujet: 'Sujet entretien',
            // contenu: 'Contenu entretien',
            action: 'Action'
          },
          columnsClasses: {
            action: 'action-xssm'
          },
          rowClassCallback(row) {
            // if(row.is_active == false){
            //   return "desactive";
            // }else if(row.profil_active[0] == undefined && row.profil_futur != undefined){
            //   return "inactive";
            // }
          },
          filterByColumn: false,
          sortable: [],
          filterable: [],
          perPage: 10,
          perPageValues: [10, 50, 500],
          orderBy: { column: "created_at", ascending: false }
        },
        errors: {
          nomInterlocuteur: '',
          prenomInterlocuteur: '',
          dateCommunication: '',
          heureCommunication: '',
          selectedType: '',
          sujet: '',
          contenu: '',
        },
      }
    },
    props: [
      'dossier',
      'traitements'
    ],
    watch: {
      heureCommunication() {
        console.log('this.heureCommunication',this.heureCommunication)
      }
    },
    async created() {
      await this.getContacts();
    },
    methods: {
      isDisabled() {
        let treatment = _.find(this.traitements, (element) => element.id === parseInt(this.$route.query.traitementId,10) );
        return isEmpty(treatment) ? true : !(treatment.categorie.toLowerCase() === 'production' && treatment.type.toLowerCase() === 'principal');
      },
      can(action, contact) {
        let user = getUser();
        if (action === 'editContact' || action === 'editCommunication' || action === 'deleteCommunication') {
          return contact.gestionnaire_id === user.id;
        } else if (action === 'deleteContact') {
          return contact.gestionnaire_id === user.id && isEmpty(contact.communications);
        }
      },
      getContacts() {
        return new Promise(async (resolve, reject) => {
          let self = this
          this.items = [];
          await this.$axios
            .get("/espaceGestion/dossier/contact/" + this.dossier.id)
            .then(response => {
              this.items = response.data.dossier_contacts;
              this.$event.emit('stopLoadingContact');
              resolve();
            })
            .catch((error) => {
              // self.$store.commit('IS_LOADING', false)
              console.log(error)
              let errorText = 'Une erreur est survenue pendant la récupération des contacts. Si le problème persiste, merci de faire un ticket au support DOSI.'
              self.$swal({
                position: 'top',
                type:'error',
                title:'Attention !!',
                text:errorText,
                showConfirmButton: false,
                timer: 6000
              })
              resolve();
            })
        })
      },
      initiateAddContact() {
        this.clearForm();
        this.clearErrors();

        this.titleModalContact = 'Création d\'un contact';
        this.$refs['modal-contact'].show();
      },
      closeModalContact() {
        this.clearForm();
        this.clearErrors();
        this.$refs['modal-contact'].hide();
      },
      closeModalCommunication() {
        this.clearErrors();
        this.clearFormCommunication();
        this.$refs['modal-communication'].hide();
      },
      clearErrors() {
        this.errors.nomInterlocuteur = '';
        this.errors.prenomInterlocuteur = '';
        this.errors.dateCommunication = '';
        this.errors.heureCommunication = '';
        this.errors.selectedType = '';
        this.errors.sujet = '';
        this.errors.contenu = '';
      },
      editContact(contact) {
        this.clearForm();
        this.clearErrors();

        this.titleModalContact = 'Modification du contact ' + contact.prenom_interlocuteur + ' ' + contact.nom_interlocuteur;
        this.contactId = contact.id;
        this.nomInterlocuteur = contact.nom_interlocuteur;
        this.prenomInterlocuteur = contact.prenom_interlocuteur;
        this.emailInterlocuteur = contact.email_interlocuteur;
        this.telephoneInterlocuteur = contact.telephone_interlocuteur;
        this.fonction = contact.fonction;
        this.$refs['modal-contact'].show();
      },
      showCommunication(contact) {
        this.contactCommunications = contact.communications;
        this.contactId = contact.id;
        this.titleCommunicationContact = 'Liste des entretiens avec ' + contact.prenom_interlocuteur + ' ' + contact.nom_interlocuteur;
        this.showCardInfosCommunication = true;
      },
      initiateAddCommunication() {
        this.clearErrors();
        this.clearFormCommunication();
        this.$refs['modal-communication'].show();
      },
      deleteCommunication(communicationId) {
        let self = this;
        let text = 'Voulez-vous supprimer cet entretien ?';

        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: text,
            type: 'warning',
            reverseButtons: false,
            showCancelButton: true,
            cancelButtonColor: '#ff1744',
            confirmButtonText: 'Supprimer',
            cancelButtonText: 'Annuler',
          })
          .then((result) => {
            if (!isEmpty(result.value) && result.value) {
              this.$axios
              .delete("/espaceGestion/dossier/communication/" + communicationId)
              .then(async response => {
                await this.getContacts();
                let contactSelected = this.items.find(contact => contact.id === this.contactId);
                this.contactCommunications = contactSelected.communications;
              })
              .catch((error) => {
                // self.$store.commit('IS_LOADING', false)
                console.log(error)
                let errorText = 'Une erreur est survenue pendant la suppression de l\'entretien. Si le problème persiste, merci de faire un ticket au support DOSI.'
                self.$swal({
                  position: 'top',
                  type:'error',
                  title:'Attention !!',
                  text:errorText,
                  showConfirmButton: false,
                  timer: 6000
                })
              })
            }
          });
      },
      deleteContact(contactId) {
        let self = this;
        let text = 'Voulez-vous supprimer cet entretien ?';
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: text,
            type: 'warning',
            reverseButtons: false,
            showCancelButton: true,
            cancelButtonColor: '#ff1744',
            confirmButtonText: 'Supprimer',
            cancelButtonText: 'Annuler',
          })
          .then((result) => {
            if (!isEmpty(result.value) && result.value) {
              this.$axios
              .delete("/espaceGestion/dossier/contact/" + contactId)
              .then(response => {
                this.getContacts();
              })
              .catch((error) => {
                // self.$store.commit('IS_LOADING', false)
                console.log(error)
                let errorText = 'Une erreur est survenue pendant la suppression du contact. Si le problème persiste, merci de faire un ticket au support DOSI.'
                self.$swal({
                  position: 'top',
                  type:'error',
                  title:'Attention !!',
                  text:errorText,
                  showConfirmButton: false,
                  timer: 6000
                })
              })
            }
          });
      },
      closeInfoCommunication() {
        this.clearForm();
        this.clearErrors();
        this.showCardInfosCommunication = false;
      },
      clearForm() {
        this.communicationId = null;
        this.contactId = null;
        this.dateCommunication = '';
        this.nomInterlocuteur = '';
        this.prenomInterlocuteur = '';
        this.emailInterlocuteur = '';
        this.telephoneInterlocuteur = '';
        this.fonction = '';
        this.sujet = '';
        this.contenu = '';
        this.selectedType = '';
      },
      clearFormCommunication() {
        this.communicationId = null;
        this.dateCommunication = '';
        this.heureCommunication = '';
        this.sujet = '';
        this.contenu = '';
        this.selectedType = '';
      },
      validateContact() {
        let valid = true;

        if (isEmpty(this.nomInterlocuteur)) {
          this.errors.nomInterlocuteur = 'Vous devez saisir le nom de l\'interlocuteur';
          valid = false;
        }
        if (isEmpty(this.prenomInterlocuteur)) {
          this.errors.prenomInterlocuteur = 'Vous devez saisir le prénom de l\'interlocuteur';
          valid = false;
        }

        return valid;
      },
      validateCommunication() {
        let valid = true;

        if (isEmpty(this.dateCommunication)) {
          this.errors.dateCommunication = 'Vous devez saisir le jour de l\'entretien';
          valid = false;
        }
        if (isEmpty(this.selectedType)) {
          this.errors.selectedType = 'Vous devez choisir le type d\'entretien';
          valid = false;
        }
        if (isEmpty(this.sujet)) {
          this.errors.sujet = 'Vous devez saisir le sujet de l\'entretien';
          valid = false;
        }
        if (isEmpty(this.contenu)) {
          this.errors.contenu = 'Vous devez saisir le contenu de l\'entretien';
          valid = false;
        }

        return valid;
      },
      formatDate(textDate) {
        let formattedDate = null;
        if(!isEmpty(textDate)) {
          formattedDate = new Date(textDate).toLocaleDateString("fr-FR");
        }
        return formattedDate;
      },
      editCommunication(communication) {
        this.clearFormCommunication();
        this.clearErrors();

        this.communicationId = communication.id;
        this.dateCommunication = communication.date_communication;
        this.heureCommunication = communication.heure_communication;
        this.sujet = communication.sujet;
        this.contenu = communication.contenu;
        this.selectedType = communication.type;

        this.$refs['modal-communication'].show();
        // this.showCardInfosCommunication = true;
      },
      saveContact() {
        this.clearErrors();
        if (this.validateContact()) {
          let self = this;
          let dataPost = {
            traitementId: parseInt(this.$route.query.traitementId,10),
            dossier_contact_id: this.contactId,
            dossier_id: this.dossier.id,
            telephone_interlocuteur: this.telephoneInterlocuteur,
            nom_interlocuteur: this.nomInterlocuteur,
            prenom_interlocuteur: this.prenomInterlocuteur,
            email_interlocuteur: this.emailInterlocuteur,
            fonction: this.fonction,
          };
          this.$axios
            .post(`/espaceGestion/dossier/contact/save`, dataPost)
            .then(async response => {
              this.clearForm();
              this.$refs['modal-contact'].hide();
              this.showCardInfosCommunication = false;
              this.getContacts();
            })
            .catch(function (error) {
              console.log(error);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue lors de l\'enregistrement du contact, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              })
            })
        }
      },
      saveCommunication() {
        this.clearErrors();
        if (this.validateCommunication()) {
          let self = this;
          let dataPost = {
            traitementId: parseInt(this.$route.query.traitementId),
            communication_id: this.communicationId,
            dossier_contact_id: this.contactId,
            dossier_id: this.dossier.id,
            date_communication: this.dateCommunication,
            heure_communication: this.heureCommunication,
            sujet: this.sujet,
            contenu: this.contenu,
            type: this.selectedType,
          };
          this.$axios
            .post(`/espaceGestion/dossier/communication/save`, dataPost)
            .then(async response => {
              // let contactId = this.contactId;
              // this.showCardInfosCommunication = false;
              this.$refs['modal-communication'].hide();
              await this.getContacts();
              let contactSelected = this.items.find(contact => contact.id === dataPost['dossier_contact_id']);
              this.contactCommunications = contactSelected.communications;
              this.clearForm();
            })
            .catch(function (error) {
              console.log(error);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue lors de la récupération de la liste des communications sur le dossier, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              })
            })
        }
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      cantEditFicheDC
    }
  }
</script>
<style scoped>
  .comment-bloc {
    border: solid 1px #1c1012;
  }
</style>
